// import ctsEn from './1080x1920_CTS_EN.mp4';
// import ctsFr from './1080x1920_CTS_FR.mp4';
import liteDisplayEn from './lite-league-display-en.mp4';
import liteDisplayFr from './lite-league-display-fr.mp4';
import liteEn from './lite-league-login-en.mp4';
import liteFr from './lite-league-login-fr.mp4';
import mvpEn from './mvp-2024-en.mp4';
import mvpFr from './mvp-2024-fr.mp4';

import liteDisplayEnWebm from './lite-league-display-en.webm';
import liteDisplayFrWebm from './lite-league-display-fr.webm';
import liteEnWebm from './lite-league-login-en.webm';
import liteFrWebm from './lite-league-login-fr.webm';
// import ctsEnWebm from './1080x1920_CTS_EN.webm';
// import ctsFrWebm from './1080x1920_CTS_FR.webm';
import mvpEnWebm from './mvp-2024-en.webm';
import mvpFrWebm from './mvp-2024-fr.webm';

export default [
    // { id: 'cts_en', mp4: ctsEn, webm: ctsEnWebm },
    // { id: 'cts_fr', mp4: ctsFr, webm: ctsFrWebm },
    { id: 'mvp_en', mp4: mvpEn, webm: mvpEnWebm },
    { id: 'mvp_fr', mp4: mvpFr, webm: mvpFrWebm },
    { id: 'lite_fr', mp4: liteFr, webm: liteFrWebm },
    { id: 'lite_en', mp4: liteEn, webm: liteEnWebm },
    { id: 'lite_display_fr', mp4: liteDisplayFr, webm: liteDisplayFrWebm },
    { id: 'lite_display_en', mp4: liteDisplayEn, webm: liteDisplayEnWebm },
];
